(function(){
	document.addEventListener('DOMContentLoaded', (e) => {
		const cta_images = document.querySelectorAll('.article-template .article__cta img');
		cta_images.forEach( img => {
			if ( img.parentNode.tagName == 'p' || img.parentNode.tagName == 'a' ){

			}
			img.parentNode.classList.add('article__cta-image')
			img.classList.add('responsive-image__image','lazyload');
      let wrapper = document.createElement('div');
      wrapper.classList.add('responsive-image__wrapper');
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
		})

		const content_images =  document.querySelectorAll('.article__content img');
    content_images.forEach( img => {
    	if ( !img.parentNode.classList.contains('article__content')) {
    		img.parentNode.style.setProperty('max-width','100%');
    	}
      
    });

		shopTheLook();
	})

	const shopTheLook = function(){
		const look_sections = document.querySelectorAll('.article__content [data-collection-handle]');
		look_sections.forEach( look => {
			if ( look.getAttribute('data-collection-handle') != null || look.getAttribute('data-collection-handle') != '' ) {
				let link = '/collections/' + look.getAttribute('data-collection-handle') + '/best-seller?view=shop-the-look',
						listing = look.querySelector('.shopthelook__listing');

				fetch(link).then(function (response) {
	        // The API call was successful!
	        return response.text();
	      }).then(function (html) {
	        
	        let parser = new DOMParser();
	        let doc = parser.parseFromString(html, 'text/html');
	        const elementList = [...doc.querySelectorAll('.shopthelook-product')];
	        const view_all = doc.querySelector('.shopthelook-viewall')
	        if (listing) {
	        	elementList.forEach( el => {
		          listing.appendChild(el);
		        });
		        if (view_all) {
		        	look.appendChild(view_all);
		        }

		        let slider = tns({
			        container: listing,
			        items: 2.5,
			        gutter: 0,
			        slideBy: 'page',
			        center: false,
			        autoplay: false,
			        controls: false,
			        nav: true,
			        navPosition: 'bottom',
			        mouseDrag: true,
			        disable: false,
			        preventScrollOnTouch: 'auto',
			        responsive: {
			          768: {
			            disable : true
			          }
			        }
			      });
	        }
	      }).catch(function (err) {
	        // There was an error
	        console.warn('Something went wrong.', err);
	      });
			}
		})
	}
})()